import { useState, useEffect } from "react";
import { getProgressSummary } from "../../api/lfApiProgress";
import ProgressOverview from "./ProgressOverview";
import StudyPlanProgress from "./StudyPlanProgress";
import ActivityHeatmap from "./ActivityHeatmap";
import Accomplishments from "./Accomplishments";
import Alerts from "./Alerts";

function ParentProgressCard({ username, childProfile }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    async function fetchProgress() {
      setLoading(true);
      setError(null);

      const response = await getProgressSummary(username, 30, setError);

      if (cancelled) return;

      if (response && response.data) {
        setData(response.data);
      } else {
        setError("Failed to load progress data.");
      }

      setLoading(false);
    }

    if (username) {
      fetchProgress();
    }

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [username]);

  if (loading) {
    return (
      <div className="flex justify-center items-center py-16">
        <div className="text-gray-400 text-sm">Loading progress...</div>
      </div>
    );
  }

  if (error && !data) {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-4 text-red-700 text-sm">
        {error}
      </div>
    );
  }

  if (!data) {
    return (
      <div className="text-gray-400 text-sm text-center py-16">
        No progress data available.
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex flex-col md:flex-row gap-6">
        {/* Main column – progress & content (2/3 width) */}
        <div className="w-full md:w-2/3 space-y-6">
          <StudyPlanProgress studyPlans={data.study_plans} />
        </div>

        {/* Right column – alerts & activity (1/3 width) */}
        <div className="w-full md:w-1/3 space-y-6">
          <Alerts alerts={data.alerts} />

          <ProgressOverview overview={data.overview} />

          <Accomplishments accomplishments={data.accomplishments} />

          <ActivityHeatmap activityHeatmap={data.activity_heatmap} />
        </div>
      </div>
    </div>
  );
}

export default ParentProgressCard;
